import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import AdminOwners from "@/components/admin/AdminOwners";

/**
 * Hub "Ajout +" regroupant la gestion des propriétaires et des logements.
 */
export default function AdminAjoutHub(props) {
  const [section, setSection] = useState("owners");

  return (
    <Card data-testid="admin-ajout-hub" className="border-white/10 bg-white/[0.08]">
      <CardHeader>
        <CardTitle data-testid="admin-ajout-hub-title" className="text-slate-100">Ajout +</CardTitle>
        <div data-testid="admin-ajout-hub-subtitle" className="text-sm text-slate-300">
          Création et gestion des propriétaires et de leurs logements.
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-wrap gap-2">
          <Button
            data-testid="admin-ajout-sub-owners"
            variant={section === "owners" ? "default" : "outline"}
            className={`rounded-full ${section === "owners" ? "bg-violet-500 text-white hover:bg-violet-400" : "border-white/10 bg-white/[0.08] text-slate-100 hover:bg-white/10"}`}
            onClick={() => setSection("owners")}
          >
            👥 Propriétaires
          </Button>
          <Button
            data-testid="admin-ajout-sub-properties"
            variant={section === "properties" ? "default" : "outline"}
            className={`rounded-full ${section === "properties" ? "bg-violet-500 text-white hover:bg-violet-400" : "border-white/10 bg-white/[0.08] text-slate-100 hover:bg-white/10"}`}
            onClick={() => setSection("properties")}
          >
            🏠 Logements
          </Button>
        </div>

        {section === "owners" && <AdminOwners mode="owners" {...props} />}
        {section === "properties" && <AdminOwners mode="properties" {...props} />}
      </CardContent>
    </Card>
  );
}
